/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/fragments/_count_down.js"
/*!*****************************************!*\
  !*** ./src/js/fragments/_count_down.js ***!
  \*****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var countDownController = function countDownController() {
  // Set target date - World Cup 2026 starts June 11, 2026
  var targetDate = new Date("June 11, 2026 00:00:00").getTime();
  // Update desktop countdown
  var daysEl = document.getElementById("days");
  var hoursEl = document.getElementById("hours");
  var minutesEl = document.getElementById("minutes");
  var secondsEl = document.getElementById("seconds");

  // Update mobile countdown
  var daysMBEl = document.getElementById("daysMB");
  var hoursMBEl = document.getElementById("hoursMB");
  var minutesMBEl = document.getElementById("minutesMB");
  var secondsMBEl = document.getElementById("secondsMB");

  // Update countdown every second
  var countdown = setInterval(function () {
    var now = new Date().getTime();
    var distance = targetDate - now;

    // Calculate time units
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);
    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = hours;
    if (minutesEl) minutesEl.textContent = minutes;
    if (secondsEl) secondsEl.textContent = seconds;
    var mobileCountdowns = [daysMBEl, hoursMBEl, minutesMBEl, secondsMBEl];
    if (daysMBEl) daysMBEl.textContent = days;
    if (hoursMBEl) hoursMBEl.textContent = hours;
    if (minutesMBEl) minutesMBEl.textContent = minutes;
    if (secondsMBEl) secondsMBEl.textContent = seconds;

    // If countdown is finished
    if (distance < 0) {
      clearInterval(countdown);
      if (daysEl) daysEl.textContent = "0";
      if (hoursEl) hoursEl.textContent = "0";
      if (minutesEl) minutesEl.textContent = "0";
      if (secondsEl) secondsEl.textContent = "0";
      mobileCountdowns.forEach(function (el) {
        return el.textContent = "0";
      });
    }
  }, 1000);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (countDownController);

/***/ },

/***/ "./src/js/fragments/_schedule.js"
/*!***************************************!*\
  !*** ./src/js/fragments/_schedule.js ***!
  \***************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var scheduleContainer = function scheduleContainer() {
  var dropdownWrappers = document.querySelectorAll(".dropdown-wrapper");
  dropdownWrappers.forEach(function (wrapper) {
    var button = wrapper.querySelector(".dropdown-wrapper__btn");
    var content = wrapper.querySelector(".dropdown-content");
    var label = wrapper.querySelector(".dropdown-label");
    var items = wrapper.querySelectorAll(".dropdown-menu button");
    var resetButton = document.querySelector(".reset-filter");

    // Toggle dropdown
    button.addEventListener("click", function (e) {
      e.stopPropagation();

      // Close all other dropdowns
      document.querySelectorAll(".dropdown-content").forEach(function (c) {
        if (c !== content) c.classList.add("hidden");
      });

      // Toggle current
      content.classList.toggle("hidden");
    });

    // Handle item selection
    items.forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.stopPropagation();

        // Remove active class from all items
        items.forEach(function (i) {
          i.classList.remove("menu-active");
          i.classList.add("menu-not-active");
        });

        // Add active class to clicked item
        item.classList.add("menu-active");
        item.classList.remove("menu-not-active");

        // Update label
        var value = item.getAttribute("data-value");
        if (value && label) {
          label.textContent = value;
          // show button reset
          resetButton.classList.add("show");
        }

        // Close dropdown
        content.classList.add("hidden");
      });
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener("click", function () {
    document.querySelectorAll(".dropdown-content").forEach(function (c) {
      c.classList.add("hidden");
    });
  });

  // filter mobile
  var button = document.querySelector(".filter__action-btn");
  var filterDropdown = document.querySelector(".filter-dropdown");
  if (!filterDropdown || !button) return;
  var step1 = filterDropdown.querySelector(".filter-step1");
  var step2 = filterDropdown.querySelector(".filter-step2");
  if (!step1 || !step2) return;
  var step2Contents = step2.querySelectorAll(".dropdown-content");

  /* =========================
      OPEN FILTER
    ========================= */
  button.addEventListener("click", function (e) {
    e.preventDefault();
    filterDropdown.classList.add("show", "step-1");
    filterDropdown.classList.remove("step-2");
  });

  /* =========================
      CLICK OUTSIDE → CLOSE
    ========================= */
  document.addEventListener("click", function (e) {
    if (!filterDropdown.contains(e.target) && !button.contains(e.target)) {
      filterDropdown.classList.remove("show", "step-1", "step-2");
    }
  });

  /* =========================
      STEP 1 → STEP 2
    ========================= */
  step1.addEventListener("click", function (e) {
    var btn = e.target.closest(".dropdown-wrapper__btn");
    if (!btn) return;
    var target = btn.dataset.target;
    if (!target) return;

    // show đúng content
    if (step2Contents.length) step2Contents.forEach(function (content) {
      content.style.display = content.dataset.option === target ? "flex" : "none";
    });
    filterDropdown.classList.remove("step-1");
    filterDropdown.classList.add("step-2");
  });

  /* =========================
      STEP 2 → STEP 1 (FIX TRIỆT ĐỂ)
    ========================= */
  step2.addEventListener("click", function (e) {
    var backBtn = e.target.closest(".group-back");
    if (!backBtn) return;
    e.preventDefault();
    filterDropdown.classList.remove("step-2");
    filterDropdown.classList.add("step-1");
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scheduleContainer);

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!**********************************!*\
  !*** ./src/js/pages/schedule.js ***!
  \**********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fragments_count_down__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../fragments/_count_down */ "./src/js/fragments/_count_down.js");
/* harmony import */ var _fragments_schedule__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../fragments/_schedule */ "./src/js/fragments/_schedule.js");


document.addEventListener("DOMContentLoaded", function () {
  (0,_fragments_count_down__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_fragments_schedule__WEBPACK_IMPORTED_MODULE_1__["default"])();
});
})();

/******/ })()
;
//# sourceMappingURL=schedule.bundle.js.map